import { BasicModel } from "../basic/basic.model";

export class ParamLandpageModel extends BasicModel {

    info: string;

    titreBouton: string;

    urlBouton: string;

    haveUrl?: boolean;

}